import styled from 'styled-components';

export const StyledTitle = styled.h3`
  padding-top: 60px;
  color: #ffffff;
  & ::selection {
    color: #1e1e1e;
    background: #aaffaa;
  }
`;